module.exports = __webpack_public_path__ + "files/explaur.a0556aa9085afcdf4f6c3bd2ebeaa5d2.pdf";